import * as React from "react";
import { useBatteryInfo } from "../../../../Pages/DigitalTwinV3/DigitalTwinContext";
import { DigitalTwinTabContainer } from "../../../../Theme/DigitalTwinStyles";
import CustomBatteryBmsFaults from "./CustomBatteryBmsFaults";

/**
 * Custom platform Alerts tab.
 *
 * Renders CustomBatteryBmsFaults which reads allowedActions from org meta
 * (metaInfo.customAlertActions) and shows only the configured action buttons.
 */
export default function CustomBatteryAlerts() {
    const { batteryID } = useBatteryInfo();

    return (
        <DigitalTwinTabContainer>
            <CustomBatteryBmsFaults batteryID={batteryID} />
        </DigitalTwinTabContainer>
    );
}
